import React,{Component} from 'react';
import Select from '@react/react-spectrum/Select';
import i18n from '../../i18n';
import _ from 'lodash';

class RejectReasons extends Component{
    constructor(props){
        super(props);
        this.state = {
            value:''
        };
    }


    change(event){
        this.props.setSelectedReason(event);
        this.setState({value: event});
    };

    componentDidMount() {
        if(this.props.rejectReasons){
            _.each(this.props.rejectReasons,function (value) {
                value.label = i18n.t('rejectReasons.'+value.key);
            });

            if(this.props.rejectReasons.length){
                this.props.setSelectedReason(this.props.rejectReasons[0].value);
                this.setState({value:this.props.rejectReasons[0].value});
            }
        }
    }

    render(){
        return(
            <div className="reject-reasons">
                <Select
                    onChange={this.change.bind(this)}
                    options={this.props.rejectReasons}
                    closeOnSelect={true}
                    value={this.state.value}
                    quiet
                    flexible
                    data-am-id="rejectReasons"
                />
            </div>
        )
    }
}


export default RejectReasons;


